export default __webpack_public_path__ + "media/images/preloader-aacf51a208c915cfcdf8a54e5455d574.png";